<template>
	<div class="study_header bg_white">
		<div class="w1200 flex">
			<div class="study_header_l">
				<img :src="public.top_logo" class="study_header_logo" />
				<div class="f20px study_header_name">·&nbsp;&nbsp;&nbsp;&nbsp;趣学习</div>
				<div class="study_header_select cl_dark">
					<el-select v-model="pharseId" placeholder="请选择" :disabled="educationTrue" class="f16px" @change="pharseSelect">
						<el-option v-for="item in pharse":key="item.pharseId" :label="item.pharseName":value="item.pharseId"></el-option>
					</el-select>
				</div>
			</div>
			<div class="study_header_r">
				<input type="text" v-model="searchText" placeholder="请输入课程名称" class="f16px" />
				<div class="study_header_btn cl_white f18px" @click="searchBtn"><img src="../../static/search_white.png" /><span>搜一搜</span></div>
			</div>
		</div>
		<div class="study_header_btm">
			<div class="w1200 flex">
				<div class="study_subject" :class="{on:subjectIndex}">
					<div class="study_subject_top cl_white f18px"><img src="../../static/subject_type.png" /><span>学科分类</span></div>
					<div class="study_subject_btm">
						<ul>
							<li v-for="(item,index) in subject" :key="index" class="study_subject_list">
								<router-link :to="{ path: '/subject', query: { id: item.subjectId }}" class="cl_white radius8"><img :src="item.icon" /><span>{{item.subjectName}}</span></router-link>
							</li>
						</ul>
					</div>
				</div>
				<div class="study_nav flex">
					<ul class="f18px">
						<li class="study_nav_list" :class="{'on':studyNav==0}"><router-link to="/study" class="cl_white block">趣学习</router-link></li>
						<li class="study_nav_list" :class="{'on':studyNav==1}"><router-link to="/practice" class="cl_white block">练习</router-link></li>
						<li class="study_nav_list" :class="{'on':studyNav==2}"><router-link to="/test_index" class="cl_white block">试卷</router-link></li>
						<li class="study_nav_list" :class="{'on':studyNav==3}"><router-link to="/famous" class="cl_white block">名校试卷</router-link></li>
						<li class="study_nav_list" :class="{'on':studyNav==4}"><router-link to="/special" class="cl_white block">学习专题</router-link></li>
						<li class="study_nav_list" :class="{'on':studyNav==5}"><router-link to="/my_course" class="cl_white block">我的课程</router-link></li>
					</ul>
					<!-- <router-link to="" class="study_nav_vip cl_yel"><img src="../../static/icon_vip.png" class="mar5" /><span>会员专享</span></router-link> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'study_header',
	  props: {
	    subjectIndex: '',
			studyNav: Number,
			myInfo: {},
			public: {},
	  },
		data () {
			return {
				// public: {}, //公共
				educationTrue: true,//是否绑定学历
				pharse: [], //学历列表
				pharseId: "",
				pharseName: "",
				searchText: "",
				subject: [],
			}
		},
		mounted() {
			this.getSubject();
		},
		created() {
			if (this.$route.query.name) {
				this.searchText = this.$route.query.name;
			}
		},
		watch: {
			myInfo: {
				handler () {
					if (JSON.stringify(this.myInfo) != "{}") {
						this.getPharse();
					}
				},
				deep: true
			}
		},
		methods: {
			//学科
			getSubject () {
				this.$get("/api/material/get_subject_data",{})
				.then(res => {
					this.subject = res.data;
				});
			},
			getPharse () {
				var that = this;
				that.$get("/api/base/get_pharse_data",{})
				.then(res => {
					that.pharse = res.data;
					if (that.myInfo.pharse_id == 0) {
						if (localStorage.getItem("pharseId")) {
							that.pharseId = parseInt(localStorage.getItem("pharseId"));
							that.pharseName = localStorage.getItem("pharseName");
						} else {
							that.pharseId = that.pharse[0].pharseId;
							localStorage.setItem("pharseId", that.pharseId);
							that.pharseName = that.pharse[0].pharseName;
							localStorage.setItem("pharseName", that.pharseName);
						}
						that.educationTrue = false;
					} else {
						that.educationTrue = true;
						that.pharseId = that.myInfo.pharse_id;
						that.pharseName = that.myInfo.pharse_name;
						localStorage.setItem("pharseId", that.pharseId);
						localStorage.setItem("pharseName", that.pharseName);
					}
					that.$emit("child-event", that.pharseId);
					that.$emit("child-name", that.pharseName);
				});
			},
			
			pharseSelect (e) {
				localStorage.setItem("pharseId", e);
				for (let i = 0; i < this.pharse.length; i++) {
					if (localStorage.getItem("pharseId") == this.pharse[i].pharseId) {
						localStorage.setItem("pharseName", this.pharse[i].pharseName);
					}
				}
				location.reload();
				// this.$emit("child-event", this.pharseId);
				// this.$emit("child-name", this.pharseName);
			},
			
			searchBtn () {
				if (this.searchText != "") {
					this.$router.push({path:'/video_search',query: {name: this.searchText}});
				}
			},
		},
	}
</script>

<style>
</style>
